<script lang="ts">
  import { Pagination } from "bits-ui";
  import Button from "@/components/ui/button/button.svelte";
  import Image from "@/components/ui/image/image.svelte";
  import { cn } from "@/helpers/tw-utils";

  import prevIcon from "@/images/chevron_left.svg";
  import nextIcon from "@/images/chevron_right.svg";
  import { localizeUrl } from "@/helpers/localization";

  interface Props {
    currentPage?: number;
    perPage?: number;
    pagesCount?: number;
  }

  let { currentPage = 1, perPage = 6, pagesCount = 1 }: Props = $props();

  let totalBlogsCount: number = perPage * pagesCount;
</script>

<Pagination.Root
  page={currentPage}
  count={totalBlogsCount}
  {perPage}
  class="flex w-full  items-center justify-center gap-2 px-4 pb-20  lg:px-20">
  {#snippet children({ pages, range })}
    <div class="order-1 my-8 flex items-center gap-2 lg:order-2">
      {#if currentPage > 1}
        <Button
          href={localizeUrl(`/blog/${currentPage - 1}/`)}
          variant="secondary"
          class=" h-10 w-10 !bg-transparent p-0 hover:!border-dark-gray hover:!bg-light-black hover:!text-theme-white">
          <Image src={prevIcon} class="h-5 w-5" />
        </Button>
      {/if}
      <div class="flex items-center gap-2.5">
        {#each pages as page (page.key)}
          {#if page.type === "ellipsis"}
            <div
              class="pointer-events-none flex h-10 w-10 items-center justify-center rounded-[8px] border border-dark-gray p-0 text-medium-gray">
              ...
            </div>
          {:else if Math.abs(currentPage - page.value) <= 2 || page.value === 1}
            <Button
              href={localizeUrl(`/blog/${page.value}/`)}
              variant="secondary"
              class={cn(
                "h-10 w-10 !bg-theme-black !bg-transparent p-0 text-medium-gray hover:!border-dark-gray",
                "hover:!bg-light-black hover:!text-theme-white",
                {
                  "!bg-accent !text-theme-white": page.value === currentPage
                }
              )}>{page.value}</Button>
          {/if}
        {/each}
      </div>
      {#if currentPage < pagesCount}
        <Button
          href={localizeUrl(`/blog/${currentPage + 1}/`)}
          variant="secondary"
          class=" h-10 w-10 !bg-transparent p-0 hover:!border-dark-gray hover:!bg-light-black hover:!text-theme-white ">
          <Image src={nextIcon} class="h-5 w-5" />
        </Button>
      {/if}
    </div>
  {/snippet}
</Pagination.Root>
